import React from 'react';
import { Button } from '../Button';
import { useTranslate } from '../util';
import { Modal, ModalBody, ModalFooter } from './Modal';
import { showModal } from './showModal';
function ConfirmModal(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(Modal, props, /*#__PURE__*/React.createElement(ModalBody, null, props.message), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button.Group, null, /*#__PURE__*/React.createElement(Button.Primary, {
    onClick: props.onCloseSuccess
  }, props.confirmText || t('citrix-ui:continue')), /*#__PURE__*/React.createElement(Button.Secondary, {
    onClick: props.onDismiss
  }, props.cancelText || t('citrix-ui:cancel')))));
}
export function confirmModal(props) {
  showModal(/*#__PURE__*/React.createElement(ConfirmModal, props));
}